import React, {lazy, Suspense} from 'react';
import { render } from 'react-dom';

/* Components */
const UserPreferencesForm = lazy(() => import(/* webpackChunkName: "UserPreferencesForm" */ './components/UserPreferencesForm'));

const containers = document.querySelectorAll('.user-preferences-form');

// Render each component
for (let i = 0; i < containers.length; i++) {
    let el = containers[i];
    let props = {};

    // Parse dataset to valid props
    for(let key in el.dataset) {
        props[key] = el.dataset[key];

        // Try to parse string to literal
        // Will parse: array, boolean, null, number, object and string
        try {
            props[key] = JSON.parse(props[key]);
        }
        catch(e) {} // eslint-disable-line no-empty
    }

    // Render component
    render(
        <Suspense fallback={<></>}>
            <UserPreferencesForm
                {...props}
                element={el}
            />
        </Suspense>,
        el
    );
}
